import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import InputFactory from "../../../../../components/InputFactory";
import AdditionalTalbePresenter from "../additional-info/AdditionalTalbePresenter";
import { DialogConfirmation } from "../../../../../components/common/Converter";
import Progress from "../../../../../components/Progress";

class OtherPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      initialData: [],
      specialSkills: "",
      nonAcademic: "",
      membershipOrg: "",
      objectID: "",
      email: sessionStorage.getItem("email"),
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "other_information";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const newObject = await findObjectUseCase().execute("other_information", {
      where: { empID: this.props.object.id },
    });
    this.setState({ initialData: newObject });
  }

  getCurrent() {
    return this.props.object.id;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.specialSkills)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.specialSkills)
      );
      if (newObjects.length > 0) {
        localStorage.setItem("OtherInfo", JSON.stringify(newObjects));
      }
    }
  }
  // delete function
  async handleDeleteData(data) {
    // const deletedData = await findObjectUseCase().execute("other_information", {
    //   where: { id: id },
    // });
    // const prevDelete =
    //   JSON.parse(localStorage.getItem("DeleteOtherInfo")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem("DeleteOtherInfo", JSON.stringify(updatedDeleteData));

    // await this.presenter.deleteObjectUseCase.execute("other_information", id);
    // dialog.close();
    // this.refetchData();
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  // edit function
  handleObjectData(object) {
    this.setState({
      objectID: object.id,
      specialSkills: object.specialSkills || "",
      nonAcademic: object.recognition || "",
      membershipOrg: object.membership || "",
    });
    dialog.fire({
      html: (
        <>
          <div className="p-2">
            <h4>Add Other Information</h4>
            <hr />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Special skills and Hobbies
            </label>
            <InputFactory
              type="String"
              field="specialSkills"
              // object={object}
              defaultValue={object.specialSkills}
              onChange={this.onChangeSkills.bind(this)}
            />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Non-Academic Distinctions / Recognition (Write in full)
            </label>
            <InputFactory
              type="String"
              field="recognition"
              // object={object}
              defaultValue={object.recognition}
              onChange={this.onChangeAcademic.bind(this)}
            />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Membership in Association/Organization (Write in full)
            </label>
            <InputFactory
              type="String"
              field="membership"
              // object={object}
              defaultValue={object.membership}
              onChange={this.onChangeMembership.bind(this)}
            />

            <div className="mt-4 mb-4 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-light fs-sm me-3"
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                onClick={this.handleSaveButton.bind(this)}
                className="btn btn-primary fs-sm me-3"
              >
                Save
              </button>
            </div>
          </div>
        </>
      ),
      footer: false,
    });
  }

  onChangeSkills(specialSkills) {
    this.setState({ specialSkills });
  }

  onChangeAcademic(nonAcademic) {
    this.setState({ nonAcademic });
  }
  onChangeMembership(membershipOrg) {
    this.setState({ membershipOrg });
  }

  async handleSaveButton() {
    if (this.state.objectID !== "") {
      const data = {
        email: this.props.object.email,
        empID: this.props.object.id,
        specialSkills: this.state.specialSkills,
        recognition: this.state.nonAcademic,
        membership: this.state.membershipOrg,
        id: this.state.objectID,
      };
      console.warn("DATAAA: ", this.state.objectID);
      await this.presenter.upsertUseCase.execute("other_information", data);
      dialog.close();
      this.refetchData();
      this.setState({ objectID: "" });
    } else {
      const data = {
        email: this.props.object.email,
        empID: this.props.object.id,
        specialSkills: this.state.specialSkills,
        recognition: this.state.nonAcademic,
        membership: this.state.membershipOrg,
      };
      console.warn("DATAAA: ", this.state.objectID);
      await this.presenter.upsertUseCase.execute("other_information", data);
      dialog.close();
      this.refetchData();
    }
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;

    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      // onClick={this.handleAddRegion.bind(this)}
                      onClick={this.handleObjectData.bind(this)}
                    >
                      <i className="bi bi-plus-lg" /> Add Other Information
                    </Button>
                  </div>
                </div>
              </div>

              <Table
                objectId={(data) => this.handleDeleteData(data)}
                objectData={this.handleObjectData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: "Remove",
                    actionType: "delete",
                  },
                  {
                    label: "Edit",
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default OtherPage;
